(function ($) {
  if(page_data) {
    if(typeof page_data['catalog-spp'] === 'object') {
      $.each(page_data['catalog-spp']['products'], function(i, v) {
        if(typeof this['SUB_LINE'] !== 'undefined')
          page_data['catalog-spp']['products'][i]['PROD_RGN_NAME'] = this['SUB_LINE'];
      });
    }
    if(typeof page_data['catalog-mpp'] === 'object') {
      $.each(page_data['catalog-mpp']['categories'], function(i, v) {
        $.each(page_data['catalog-mpp']['categories'][i]['products'], function(j, w) {
          if(typeof this['SUB_LINE'] !== 'undefined')
            page_data['catalog-mpp']['categories'][i]['products'][j]['PROD_RGN_NAME'] = this['SUB_LINE'];
        });
      });
    }
    if(typeof page_data['catalog-spp-workswith'] === 'object') {
      $.each(page_data['catalog-spp-workswith']['products'], function(i, v) {
        if(typeof this['SUB_LINE'] !== 'undefined')
          page_data['catalog-spp-workswith']['products'][i]['PROD_RGN_NAME'] = this['SUB_LINE'];
      });
    }
  }
})(jQuery);

